import React from "react";
import "./RestrictionsBanner.css";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const RestrictionsBanner = ({ onLoad }) => {
  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div className="">
            <div
              className="container-fluid ctm-banner position-relative p-0"
              style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
            >
              <img
                src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/11.%20Restrictions%20&%20guidance.webp"
                alt="Global Travel Restrictions"
                className="w-100"
                loading={useHighRes ? "eager" : "lazy"}
                onLoad={handleImageLoad}
                fetchpriority={useHighRes ? "high" : "auto"}
              />
              {imageLoaded ? (
                <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
                  <p className="fs4 text-uppercase busy grotesk-headings">
                    GLOBAL TRAVEL
                  </p>
                  <h1 className="banner-headings w-100">
                    Navigate Travel <br />
                    with Confidence
                  </h1>
                  <div className="d-flex common-second-content">
                    <div className="ornge-border"></div>
                    <div className="second-content">
                      Are travel restrictions holding you back from your next
                      business trip? Let us guide you through the latest travel
                      guidelines so you can focus on what matters most—your
                      success.
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {imageLoaded ? (
              <div className="container why-staying px-md-5">
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="headings">
                      <span>Why </span>Staying Informed Matters in Corporate
                      Travel
                    </h1>
                    <p className="mt-3">
                      Navigating travel restrictions and guidelines in today’s
                      modern world can be challenging, but Blueberry Travel
                      ensures you’re always updated. We provide real-time
                      information on travel restrictions, health protocols, and
                      entry requirements to make your journey seamless and
                      stress-free.
                    </p>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </BannerWrapper>
    </>
  );
};

export default RestrictionsBanner;
